class ShoppableFeed extends HTMLElement {
  constructor() {
    super();

    this.sliderEl = this.querySelector('.shoppable-feed__slider');
    this.slides = this.querySelectorAll('.shoppable-feed__slide');
    this.volumeButtons = this.querySelectorAll('.shoppable-feed__media-volume');

    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.init();
    this.initializeVideos();
  }

  disconnectedCallback() {
    if (this.slider) this.slider.destroy();

    this.removeEventListener('click', this.boundHandleClick);
  }

  initializeVideos() {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.loadVideos();
      },
      {
        rootMargin: '0px',
        threshold: 0.1
      }
    );
    this.observer.observe(this);
  }

  loadVideos() {
    this.slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;

      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach(source => {
        source.src = source.dataset.src;
      });

      // Reload video to apply preload metadata
      video.load();

      if (index == 0) {
        video.play().catch(error => {
          console.log('Video play failed:', error);
        });
      }

      // Store reference to slide index
      video.dataset.slideIndex = index;
    });
  }

  init() {
    if (!this.sliderEl) return;
    
    this.slider = new Flickity( this.sliderEl, {
      cellAlign: 'center',
      percentPosition: false,
      prevNextButtons: false,
      wrapAround: true,
    });

    this.slider.on( 'change', (index) => {
      this.slides.forEach((slide, slideIndex) => {
        const video = slide.querySelector('video');
        if (!video) return;
        
        if (slideIndex == index) {
          slide.querySelector('video').play();
        } else {
          slide.querySelector('video').pause();
        }
      });
    });

    this.addEventListener('click', this.boundHandleClick);
  }

  handleClick(event) {
    if (event.target.closest('.shoppable-feed__media-volume')) {
      this.handleVolumeClick();
    }
  }

  handleVolumeClick() {
    const isMuted = this.slides[0].querySelector('video').muted;
  
    this.volumeButtons.forEach((volumeButton) => {
      volumeButton.classList.toggle('unmute', isMuted);
    });


    this.slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        video.muted = !isMuted;
      }
    });
  }
}

if (!customElements.get('shoppable-feed')) {
  customElements.define('shoppable-feed', ShoppableFeed);
}